import FlexBox from '@component/FlexBox/FlexBox';
import Label from '@component/Label';
import NumberInput from '@component/NumberInput';
import TextInput from '@component/TextInput';
import { EssayAnswerQuestion as EssayAnswerQuestionType } from '@container/Challenge/NewChallengeForm/NewChallengeForm.types';

type MultipleChoiceQuestionProps = {
  question: EssayAnswerQuestionType;
  questionIndex: number;
  onQuestionChange: <T extends keyof EssayAnswerQuestionType>(input: {
    fieldName: T;
    value: EssayAnswerQuestionType[T];
  }) => void;
};

const EssayAnswerQuestion = (props: MultipleChoiceQuestionProps) => {
  const { question, questionIndex, onQuestionChange } = props;
  return (
    <FlexBox.Column style={{ marginTop: 20 }}>
      <h4>질문 {questionIndex + 1}</h4>
      <FlexBox.Column style={{ marginLeft: 12 }}>
        <Label>질문 내용</Label>
        <TextInput
          style={{ marginBottom: 12 }}
          value={question.title}
          placeholder="질문 내용"
          onChange={(text) =>
            onQuestionChange({
              fieldName: 'title',
              value: text,
            })
          }
        />
        <Label>제목 최소길이</Label>
        <NumberInput
          style={{ marginBottom: 12 }}
          value={question.answerTitle.minLength}
          placeholder="제목 최소길이"
          onChange={(value) =>
            onQuestionChange({
              fieldName: 'answerTitle',
              value: {
                ...question.answerTitle,
                minLength: value,
              },
            })
          }
        />
        <Label>제목 최대길이</Label>
        <NumberInput
          style={{ marginBottom: 12 }}
          value={question.answerTitle.maxLength}
          placeholder="제목 최대길이"
          onChange={(value) =>
            onQuestionChange({
              fieldName: 'answerTitle',
              value: {
                ...question.answerTitle,
                maxLength: value,
              },
            })
          }
        />
        <Label>내용 최소길이</Label>
        <NumberInput
          style={{ marginBottom: 12 }}
          value={question.answerContent.minLength}
          placeholder="내용 최소길이"
          onChange={(value) =>
            onQuestionChange({
              fieldName: 'answerContent',
              value: {
                ...question.answerContent,
                minLength: value,
              },
            })
          }
        />
        <Label>내용 최대길이</Label>
        <NumberInput
          style={{ marginBottom: 12 }}
          value={question.answerContent.maxLength}
          placeholder="내용 최대길이"
          onChange={(value) =>
            onQuestionChange({
              fieldName: 'answerContent',
              value: {
                ...question.answerContent,
                maxLength: value,
              },
            })
          }
        />
      </FlexBox.Column>
    </FlexBox.Column>
  );
};

export default EssayAnswerQuestion;
